import React from 'react';

const LABELS = {
  draft: 'Draft',
  deployed: 'Deployed',
  disabled: 'Disabled',
  expired: 'Expired',
};

export function StatusBadge({ status }) {
  return <span className={`status-badge status-${status}`}>{LABELS[status] || status}</span>;
}
